import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationtaxiservice() {



    const cardData = {

keyword: "Outstation Taxi Service in Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Outstation Taxi Service in Mumbai for one-way trips, round trips, weekend getaways, family tours, corporate travel, pilgrimage journeys, and long-distance intercity rides. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup and drop across Mumbai, flexible travel plans, and safe highway driving, we ensure a smooth, comfortable, and hassle-free outstation travel experience across India.",

topPlaces: [
    {
        title: "Mahabaleshwar Hill Station",
        description:
            "Mahabaleshwar is one of Maharashtra’s most popular hill stations known for strawberry farms, viewpoints, lakes, and pleasant weather. It is a top weekend getaway destination from Mumbai for families and couples."
    },
    {
        title: "Goa Beach Destination",
        description:
            "Goa is India’s most famous beach destination known for nightlife, water sports, beaches, and Portuguese heritage. It is a highly preferred long-distance outstation taxi route from Mumbai."
    },
    {
        title: "Shirdi Sai Baba Temple",
        description:
            "Shirdi is one of India’s most important pilgrimage destinations dedicated to Sai Baba. Devotees frequently book outstation taxis from Mumbai for comfortable and convenient darshan trips."
    },
    {
        title: "Pune City & IT Hub",
        description:
            "Pune is a major IT, education, and business hub near Mumbai. It is one of the most frequently traveled outstation routes for corporate, student, and family travel."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is known for vineyards, temples, and Trimbakeshwar Jyotirlinga. It is a popular pilgrimage and weekend travel destination from Mumbai."
    },
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are scenic hill stations famous for valleys, waterfalls, and monsoon beauty. They are ideal for short outstation trips from Mumbai."
    },
    {
        title: "Alibaug Beach & Coastal Escape",
        description:
            "Alibaug is a peaceful beach destination near Mumbai known for clean beaches, forts, and resorts. It is perfect for quick weekend getaways."
    },
    {
        title: "Aurangabad Heritage City",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, making it a top historical and cultural travel destination from Mumbai for heritage lovers."
    },
    {
        title: "Kolhapur Temple City",
        description:
            "Kolhapur is known for Mahalaxmi Temple, rich culture, and traditional cuisine. It is a popular pilgrimage and family travel destination from Mumbai."
    },
    {
        title: "Matheran Hill Station",
        description:
            "Matheran is Asia’s only automobile-free hill station known for toy train rides, viewpoints, and peaceful natural surroundings close to Mumbai."
    }
],



services: [
{
name: "Mumbai to Pandharpur Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Pandharpur Cab Booking service for comfortable and reliable pilgrimage travel to the holy town of Pandharpur, home to Lord Vitthal and Rukmini temple. Our service is designed for families, devotees, and group travellers seeking a peaceful and well-organized spiritual journey. We provide well-maintained vehicles including Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and Mini Bus options depending on group size. With professional chauffeurs experienced in long-distance and temple routes, we ensure safe travel, timely arrival for darshan, flexible pickup and drop service, transparent pricing, and 24x7 support. Whether it is a one-day visit, weekend pilgrimage, or extended religious tour, our service ensures a smooth, devotional, and stress-free travel experience."
},
{
name: "Mumbai to Akkalkot Cab",
description: "Mumbai Airport Cab provides Mumbai to Akkalkot Cab service for devotees travelling to the sacred town of Akkalkot, known for Shri Swami Samarth Maharaj temple. Our pilgrimage cab service ensures comfortable and safe transportation for families and groups visiting for darshan and spiritual visits. We offer clean, air-conditioned vehicles, experienced chauffeurs familiar with temple routes, flexible travel schedules, and doorstep pickup and drop service. With transparent pricing and reliable support, we make your spiritual journey peaceful and well-organized."
},
{
name: "Mumbai to Tuljapur Cab",
description: "Book Mumbai to Tuljapur Cab with Mumbai Airport Cab for convenient travel to Shri Tulja Bhavani Temple, one of Maharashtra’s most important Shakti Peeths. Our service is ideal for family pilgrimages, religious groups, and devotees seeking safe and comfortable travel. We provide spacious vehicles, professional drivers, luggage support, and flexible itinerary options. Whether it is a same-day darshan or overnight trip, we ensure timely travel, comfort, and a smooth devotional experience."
},
{
name: "Mumbai Pilgrimage Cab Service",
description: "Mumbai Airport Cab offers Mumbai Pilgrimage Cab Service for devotees travelling to major spiritual destinations across Maharashtra and India. Our service covers temple tours, yatras, and religious circuits with comfortable vehicles, experienced chauffeurs, and customized travel planning. We ensure safe highway travel, punctual pickups, flexible routes, and complete assistance for family and group pilgrimage journeys, making your spiritual travel meaningful and hassle-free."
},
{
name: "Pandharpur Taxi from Mumbai",
description: "Pandharpur Taxi from Mumbai service provides direct and comfortable transportation for devotees travelling to Vitthal Rukmini Temple. Mumbai Airport Cab ensures smooth long-distance travel with well-maintained vehicles, professional drivers, and flexible pickup options from any location in Mumbai. We focus on safety, comfort, and timely arrival so passengers can enjoy peaceful darshan without travel stress."
},
{
name: "Akkalkot Darshan Cab Mumbai",
description: "Akkalkot Darshan Cab Mumbai service is specially designed for devotees visiting Shri Swami Samarth Maharaj temple. Mumbai Airport Cab provides comfortable vehicles, experienced chauffeurs familiar with pilgrimage routes, and flexible travel plans for families and groups. We ensure safe travel, convenient pickup and drop service, and a peaceful spiritual journey experience."
},
{
name: "Tuljapur Bhavani Temple Cab",
description: "Tuljapur Bhavani Temple Cab service offers reliable transportation for devotees visiting Shri Tulja Bhavani Temple from Mumbai and nearby cities. Mumbai Airport Cab provides clean, air-conditioned vehicles, professional drivers, and customized travel schedules for family and group pilgrimage tours. We ensure timely darshan visits, safe highway travel, and comfortable journey experiences."
},
{
name: "Mumbai Religious Tour Cab",
description: "Mumbai Religious Tour Cab service provides complete transportation solutions for spiritual tours covering multiple temples and pilgrimage destinations across Maharashtra and India. Mumbai Airport Cab offers flexible itineraries, experienced chauffeurs, and comfortable vehicles for families and groups. We ensure smooth travel planning, safe journeys, and a peaceful devotional experience throughout the tour."
},
{
name: "Maharashtra Pilgrimage Cab Package",
description: "Maharashtra Pilgrimage Cab Package by Mumbai Airport Cab offers curated travel routes covering major religious destinations such as Pandharpur, Shirdi, Trimbakeshwar, Bhimashankar, Tuljapur, Akkalkot, and more. Our packages include comfortable vehicles, professional drivers, flexible scheduling, and customized itineraries. We ensure a complete spiritual travel experience with convenience, safety, and devotion."
},
{
name: "Pandharpur Vitthal Darshan Cab",
description: "Pandharpur Vitthal Darshan Cab service provides dedicated transportation for devotees visiting Lord Vitthal temple. Mumbai Airport Cab ensures comfortable travel with experienced drivers, clean vehicles, and flexible departure timings aligned with darshan schedules. We focus on providing a peaceful, organized, and safe pilgrimage journey."
},
{
name: "Akkalkot Swami Samarth Cab",
description: "Akkalkot Swami Samarth Cab service offers comfortable and reliable transportation for devotees visiting the sacred Swami Samarth Maharaj temple. Mumbai Airport Cab provides spacious vehicles, professional chauffeurs, and flexible travel arrangements for families and groups. We ensure safe travel, timely darshan, and a smooth spiritual experience."
},
{
name: "Tuljapur Temple Travel Cab",
description: "Tuljapur Temple Travel Cab service by Mumbai Airport Cab ensures convenient transportation for pilgrims visiting the Bhavani Mata temple. Our service includes comfortable vehicles, experienced drivers, and flexible travel plans suitable for families and religious groups. We prioritize safety, punctuality, and comfort for a stress-free pilgrimage journey."
},
{
name: "Mumbai Spiritual Tour Cab",
description: "Mumbai Spiritual Tour Cab service offers customized travel for spiritual seekers visiting temples, ashrams, and pilgrimage destinations across Maharashtra. Mumbai Airport Cab provides comfortable vehicles, knowledgeable drivers, and flexible itineraries to ensure a peaceful and meaningful travel experience for individuals and groups."
},
{
name: "Maharashtra Temple Tour Cab",
description: "Maharashtra Temple Tour Cab service provides organized transportation for multi-temple pilgrimage circuits across the state. Mumbai Airport Cab offers comfortable vehicles, professional chauffeurs, and customized tour planning for destinations like Pandharpur, Shirdi, Nashik, Tuljapur, Akkalkot, and more. We ensure smooth, safe, and devotional travel experiences."
},
{
name: "Mumbai Devotional Cab Service",
description: "Mumbai Devotional Cab Service is designed for pilgrims and families travelling to religious destinations for worship and spiritual journeys. Mumbai Airport Cab provides well-maintained vehicles, experienced drivers, and flexible travel schedules. We ensure safe, comfortable, and peaceful transportation for all devotional trips."
},
{
name: "Pilgrimage Tour Mumbai Cab",
description: "Pilgrimage Tour Mumbai Cab service offers complete travel solutions for religious journeys starting from Mumbai to major temples and spiritual destinations. Mumbai Airport Cab provides comfortable vehicles, customized itineraries, and professional chauffeurs to ensure a smooth and meaningful pilgrimage experience for families and groups."
},
{
name: "Mumbai Family Yatra Cab",
description: "Mumbai Family Yatra Cab service is ideal for families planning religious tours, temple visits, and spiritual journeys together. Mumbai Airport Cab provides spacious vehicles, safe drivers, flexible schedules, and comfortable seating to ensure a smooth and enjoyable pilgrimage experience for all family members."
}
],

tableData: [
["Mumbai to Pandharpur Cab Booking","Mumbai to Akkalkot Cab"],
["Mumbai to Tuljapur Cab","Mumbai Pilgrimage Cab Service"],
["Pandharpur Taxi from Mumbai","Akkalkot Darshan Cab Mumbai"],
["Tuljapur Bhavani Temple Cab","Mumbai Religious Tour Cab"],
["Maharashtra Pilgrimage Cab Package","Pandharpur Vitthal Darshan Cab"],
["Akkalkot Swami Samarth Cab","Tuljapur Temple Travel Cab"],
["Mumbai Spiritual Tour Cab","Maharashtra Temple Tour Cab"],
["Mumbai Devotional Cab Service","Pilgrimage Tour Mumbai Cab"],
["Mumbai Family Yatra Cab","Mumbai Pilgrimage Travel Cab"]
],





whychoose: [
    {
        WhyChooseheading: "Reliable Outstation Taxi Service in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Outstation Taxi Services in Mumbai for family vacations, business trips, religious tours, airport transfers, and long-distance travel across India."
    },
    {
        WhyChooseheading: "Travel to Popular Destinations Across India",
        WhyChoosedescription: "Customers can book outstation taxis from Mumbai to Pune, Nashik, Shirdi, Mahabaleshwar, Lonavala, Goa, Ahmedabad, Indore, Bangalore, Jaipur, and many other destinations."
    },
    {
        WhyChooseheading: "Comfortable Long-Distance Travel Experience",
        WhyChoosedescription: "Our well-maintained vehicles ensure comfortable journeys with spacious seating, smooth rides, and convenient travel for individuals, families, and groups."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to your travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "We offer flexible travel solutions including one-way transfers, round trips, multi-city journeys, and customized outstation travel packages."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Mumbai",
        WhyChoosedescription: "Pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and surrounding areas."
    },
    {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced in long-distance driving and ensure safe, punctual, and stress-free travel throughout the journey."
    },
    {
        WhyChooseheading: "Perfect for Family, Corporate, and Religious Tours",
        WhyChoosedescription: "Whether you are planning a family holiday, corporate visit, pilgrimage tour, wedding event, or group outing, we provide suitable transportation solutions."
    }
]
};

const faqData = [
    {
        question: "What is Outstation Taxi Service in Mumbai?",
        answer: "Outstation Taxi Service allows customers to travel from Mumbai to destinations outside the city for business, tourism, family visits, religious tours, and long-distance travel."
    },
    {
        question: "Which destinations can I travel to from Mumbai?",
        answer: "Customers can book taxis for Pune, Nashik, Shirdi, Mahabaleshwar, Lonavala, Goa, Ahmedabad, Indore, Jaipur, Bangalore, and many other cities."
    },
    {
        question: "Can I book a one-way outstation taxi?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicles are available for outstation travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and luxury vehicles are available."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate teams, religious tours, and sightseeing trips."
    },
    {
        question: "Can I customize my travel itinerary?",
        answer: "Yes, customers can include multiple destinations, sightseeing locations, temple visits, business meetings, and personal stops."
    },
    {
        question: "Is airport pickup available for outstation travel?",
        answer: "Yes, customers can start their outstation journey directly from Mumbai Airport."
    },
    {
        question: "Are drivers experienced in interstate travel?",
        answer: "Yes, our drivers are experienced in long-distance and interstate routes, ensuring safe and comfortable travel."
    },
    {
        question: "Is advance booking recommended for outstation taxis?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning."
    },
    {
        question: "How can I book an Outstation Taxi Service in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nitin Deshpande",
        feedback:
            "We booked an outstation taxi for a family trip from Mumbai to Mahabaleshwar. The vehicle was comfortable, the driver was professional, and the entire journey was enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Anjali Patil",
        feedback:
            "Mumbai Airport Cabs handled our long-distance travel perfectly. The booking process was smooth, the cab was well-maintained, and we reached our destination safely and comfortably.",
        rating: 5
    }
];








































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Outstation Taxi Service in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/outstation-taxi-service-mumbai.jpg",
"description": "Book outstation taxi service in Mumbai for long-distance travel, weekend trips, hill station tours, and intercity journeys. Mumbai Airport Cabs offers reliable outstation cab service with professional drivers, clean vehicles, one-way and round-trip options, and affordable pricing.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/outstation-taxi-service-in-mumbai"
}
};



    return (
        <div>



<Helmet>
  <title>Outstation Taxi Service in Mumbai | Long Distance Cab | +91 9545731161</title>

<meta
 name="description"
 content="Book outstation taxi service in Mumbai for long-distance trips, weekend getaways, hill stations, and intercity travel. Reliable cab service with professional drivers and affordable fares."
/>

<meta
 name="keywords"
 content="outstation taxi service in mumbai, mumbai outstation cab service, outstation cab mumbai, mumbai intercity taxi service, long distance taxi mumbai, mumbai highway taxi service, mumbai outstation car hire, mumbai outstation travel cab, mumbai road trip taxi service, mumbai one way outstation cab, mumbai round trip outstation cab, mumbai hill station cab service, mumbai holiday travel cab, mumbai weekend outstation cab, mumbai tourism taxi service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>










            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/59.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Outstationtaxiservice;